const fieldsToCapture = [
  {
    inputSelector: '[data-hidden-content]',
    key: 'rs_utm_content',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-term]',
    key: 'rs_utm_term',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-source]',
    key: 'rs_utm_source',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-medium]',
    key: 'rs_utm_medium',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-campaign]',
    key: 'rs_utm_campaign',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-ga-id]',
    key: '_gaRollup',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-third-party-campaign-id]',
    key: 'rs_campaign_id',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-google-click-id]',
    key: 'rs_gclid',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-google-client-id]',
    key: '_ga',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-meta-click-id]',
    key: 'fbclid',
    sourceType: 'query-parameter'
  },
  {
    inputSelector: '[data-hidden-lead-source]',
    key: 'rs_lead_source',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-crm-campaign-name]',
    key: 'rs_crm_campaign_name',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-hidden-source-url]',
    sourceType: 'url'
  }
];

const getCookieByKey = (key) => {
  const match = document.cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
  if (!match) {
    return null;
  }
  return match[2];
};

const getQueryParameterByKey = (key) =>
  new URLSearchParams(window.location.search).get(key);

const getFieldByKey = (sourceType, key) => {
  switch (sourceType) {
    case 'cookie':
      return getCookieByKey(key, document.cookie);
    case 'query-parameter':
      return getQueryParameterByKey(key);
    case 'url':
      return window.location.origin + window.location.pathname;
    default:
      return null;
  }
};

const captureField = ({ inputSelector, key, sourceType }) => {
  const input = document.querySelector(inputSelector);
  const value = getFieldByKey(sourceType, key);
  if (input && value) {
    input.value = value;
  }
};

export const captureAnalytics = () => {
  fieldsToCapture.forEach(captureField);
};
